module.exports = __webpack_public_path__ + "static/parents-selfie-0ecfc84eede7a4d9e8ba90bd00de6d8e.jpg";